import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.9402 0.388036C14.0528 0.659926 14.0064 0.89189 13.8008 1.08393L8.906 5.98586V13.3635C8.906 13.642 8.77684 13.8377 8.51852 13.9505C8.4322 13.9835 8.3495 14 8.27042 14C8.09184 14 7.94292 13.937 7.82364 13.8109L5.28235 11.2659C5.15648 11.1399 5.09355 10.9907 5.09355 10.8185V5.98586L0.19876 1.08393C-0.00617797 0.89189 -0.052635 0.659926 0.0593891 0.388036C0.172072 0.129345 0.367455 0 0.645538 0H13.354C13.6321 0 13.8275 0.129345 13.9402 0.388036Z",
		fill: "#44C571"
	})
});
export default SvgFilterIcon;
